var poll_default = {
  "fontElementMap": "ogPuq",
  "container": "YvZYh",
  "fullscreen": "OCEkH",
  "background_overlay": "OopNr",
  "with_image": "wjyxQ",
  "options": "Q2b4g",
  "webview": "XmTEo",
  "grid": "ceH7g",
  "option": "ueOyH",
  "cta_button": "aIcU1",
  "add_option": "Rlviq",
  "see_more": "o3-Ee",
  "list": "kSY9x",
  "column": "CjTM5",
  "additional_note": "-NCcM",
  "spinner": "_7YD4g",
  "spin": "iHrbS",
  "shown": "zff90",
  "error": "nmpEW"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
